export const OPTIONAL_QUANTITY_LABELS = [
  "completar missao assim que iniciada",
];
